import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigurationService } from '@core/services';
import { UserClaims } from '@okta/okta-auth-js';
import { firstValueFrom, Observable } from 'rxjs';
import { OktaIntegrationService } from '../../services/okta-integration.service';

@Component({
  standalone: false,
  selector: 'app-okta-container',
  templateUrl: './okta-container.component.html',
  styleUrls: ['./okta-container.component.css'],
})
export class OktaContainerComponent implements OnInit {
  @Input() text: string;
  @Output() patronEmmiter: EventEmitter<UserClaims> = new EventEmitter();

  patron: UserClaims | null = null;
  isAuthenticated$!: Observable<boolean>;
  isAuthenticated: boolean = false;

  private _oktaService = inject(OktaIntegrationService);
  public configurationService = inject(ConfigurationService);
  private readonly destroyRef = inject(DestroyRef);

  async ngOnInit(): Promise<void> {
    this.isAuthenticated$ = this._oktaService.getIsAuthenticated();
    if (await firstValueFrom(this.isAuthenticated$)) {
      this.isAuthenticated = true;
      this.patron = await this._oktaService.getUserInfo();

      this.patronEmmiter.emit(this.patron);
    }
  }

  async signInRedirect(): Promise<void> {
    let origin = window.location.href;

    this._oktaService
      .signInWithRedirect(origin, 'okta/redirect')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();

    const isAuthenticated = await firstValueFrom(
      this._oktaService.getIsAuthenticated()
    );
    if (isAuthenticated) {
      this.isAuthenticated = true;
      this.patron = await this._oktaService.getUserInfo();
      this.patronEmmiter.emit(this.patron);
    }
  }
}
